function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoGreen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M9.99996 1.6665C5.40829 1.6665 1.66663 5.40817 1.66663 9.99984C1.66663 14.5915 5.40829 18.3332 9.99996 18.3332C14.5916 18.3332 18.3333 14.5915 18.3333 9.99984C18.3333 5.40817 14.5916 1.6665 9.99996 1.6665ZM9.37496 6.6665C9.37496 6.32484 9.65829 6.0415 9.99996 6.0415C10.3416 6.0415 10.625 6.32484 10.625 6.6665V10.8332C10.625 11.1748 10.3416 11.4582 9.99996 11.4582C9.65829 11.4582 9.37496 11.1748 9.37496 10.8332V6.6665ZM10.7666 13.6498C10.725 13.7582 10.6666 13.8415 10.5916 13.9248C10.5083 13.9998 10.4166 14.0582 10.3166 14.0998C10.2166 14.1415 10.1083 14.1665 9.99996 14.1665C9.89163 14.1665 9.78329 14.1415 9.68329 14.0998C9.58329 14.0582 9.49163 13.9998 9.40829 13.9248C9.33329 13.8415 9.27496 13.7582 9.23329 13.6498C9.19163 13.5498 9.16663 13.4415 9.16663 13.3332C9.16663 13.2248 9.19163 13.1165 9.23329 13.0165C9.27496 12.9165 9.33329 12.8248 9.40829 12.7415C9.49163 12.6665 9.58329 12.6082 9.68329 12.5665C9.88329 12.4832 10.1166 12.4832 10.3166 12.5665C10.4166 12.6082 10.5083 12.6665 10.5916 12.7415C10.6666 12.8248 10.725 12.9165 10.7666 13.0165C10.8083 13.1165 10.8333 13.2248 10.8333 13.3332C10.8333 13.4415 10.8083 13.5498 10.7666 13.6498Z",
    fill: "#4A878D",
    style: {
      fill: "#4A878D",
      fill: "color(display-p3 0.2902 0.5307 0.5542)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoGreen);
export default __webpack_public_path__ + "static/media/info_green.8dd8416de79dbe1f088c9f7e1d2c6509.svg";
export { ForwardRef as ReactComponent };